import React from 'react';
import CategoryLandingTemplate from '../../components/CategoryLandingTemplate';
import tecnalData from '../../data/tecnal';

const EtanolMaizPage = () => {
  return <CategoryLandingTemplate data={tecnalData['etanol-de-maiz']} />;
};

export default EtanolMaizPage;
